import { useEffect, useState } from "react";

export const HealthGauge = ({ score = 0, size = 220 }) => {
  const [display, setDisplay] = useState(0);
  const stroke = 16;
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;

  const color = score >= 80 ? "#10B981" : score >= 55 ? "#F59E0B" : "#EF4444";
  const label = score >= 80 ? "Healthy" : score >= 55 ? "Needs Attention" : "Critical";

  useEffect(() => {
    let raf;
    const start = performance.now();
    const from = display;
    const dur = 1100;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(from + (score - from) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [score]);

  const offset = circ - (display / 100) * circ;

  return (
    <div className="relative grid place-items-center" style={{ width: size, height: size }} data-testid="health-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="rgba(148,163,184,0.14)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke 0.4s ease", filter: `drop-shadow(0 0 10px ${color}66)` }}
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <p className="font-heading font-extrabold text-5xl tracking-tight" style={{ color }} data-testid="health-score-value">
            {display}
          </p>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mt-1">Health Score</p>
          <p className="text-sm font-semibold mt-1" style={{ color }}>{label}</p>
        </div>
      </div>
    </div>
  );
};
